import {
    createContext,
    ReactNode,
    useContext,
    useEffect,
    useState,
} from "react";
import { SessionInfo } from "../models/sessions";
import { Session } from "../apis/sessions";

import Debug from 'debug';
import { UserItem } from "../models/users";
const log = Debug('judging-sdk:SessionProvider');

export type SessionState = {
    sessionInfo: SessionInfo,
    userInfo: UserItem | null,
    isLoggedIn: boolean
} | undefined;

type SessionStateCompanion = {
    isSystemAdministrator(session: SessionState | null): boolean;
    isTester(session: SessionState | null): boolean;
}

export const SessionState: SessionStateCompanion = {
    isSystemAdministrator(session: SessionState | null): boolean {
        return session ? session.userInfo ? session.userInfo.user_status >= 100 : false : false;
    },
    isTester(session: SessionState | null): boolean {
        return session ? session.userInfo ? session.userInfo.user_status >= 10 : false : false;
    }
}

interface SessionProps {
    children?: ReactNode;
}

const SessionContext = createContext<SessionState>(undefined);

export const SessionProvider = (props: SessionProps) => {
    const [ session, setSession ] = useState<SessionState>();

    useEffect(() => {
        const subscription = Session.get().addListener(async session => {
            log("Received session update", session);

            const userInfo = Session.get().getUserInfo();

            setSession({
                sessionInfo: session,
                userInfo: userInfo,
                isLoggedIn: session && session.user_id != "0"
            });
        });

        return () => subscription.remove();
    }, []);

    return (
        <SessionContext.Provider value={session}>
            {props.children}
        </SessionContext.Provider>
    );
};

export const useSession = () => useContext(SessionContext);
